<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="activeName || $route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <!-- 改成汉字 -->
          <div v-show="!collapsed">
            <img :src="minLogo" key="min-logo" style="width: 24px; height: 24px; display: inline-block; vertical-align: middle;margin-right: 5px;" />
            <span class="mainTitle">AI工具箱</span>
          </div>
          <!-- <img v-show="!collapsed" :src="maxLogo" key="max-logo" /> -->
          <img v-show="collapsed" :src="minLogo" key="min-logo" style="width: 24px; height: 24px; margin: 10px auto;" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <div class="mpoint" @click="loginOut">
            退出登录
          </div>
          <!-- <div class="mr10">
            欢迎&nbsp;&nbsp;
          </div> -->
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <!-- <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div> -->
          <Content class="content-wrapper" id="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view/>
            </keep-alive>
            <img v-if="isShowBg" class="bgWelcome" src="./assets/images/common/welcome.png" alt="欢迎">
          </Content>
        </Layout>
      </Content>
    </Layout>
    <Button @click="goTop" type="primary" shape="circle" icon="md-arrow-round-up" style=" padding: 0px; width: 40px; font-size: 25px; height: 40px;position: fixed; bottom: 10px; right: 10px;z-index: 99999;" v-show="isShowToTop"></Button>
  </Layout>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import * as dd from 'dingtalk-jsapi';
import SideMenu from '@/components/side-menu';
import HeaderBar from '@/components/header-bar';
import TagsNav from '@/components/tags-nav';
import routers from './router/modules';
import util from '@assets/js/util';
import '@assets/styles/homepage/index.less';
export default {
  name: 'myMain',
  data () {
    return {
      activeName: '',
      isShowBg: true,
      collapsed: false, // 是否缩略图模式
      isShowToTop: false, // 是否显示回到顶部
      userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : '--',
      minLogo: require('./assets/images/index/index_title.png'), // 小lOGO
      maxLogo: require('./assets/images/index/index_title.png') // 大 logo
    };
  },
  computed: {
    tagNavList () {
      return this.$store.state.app.tagNavList;
    },
    cacheList () {
      const list = ['ParentView', 'commonRouterView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []];
      return list;
    },
    menuList () { // tree data
      return this.$store.getters.menuList;
    }
  },
  methods: {
    ...mapMutations([
      'setHomeRoute',
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'closeTag'
    ]),
    turnToPage (route) { // tree 节点click
      let { name, params, query } = {};
      if (typeof route === 'string') name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query
      });
    },
    handleCollapsedChange (state) { // 左侧展开/收缩
      this.collapsed = state;
    },
    loginOut () {
      this.$Modal.confirm({
        title: '退出登录',
        content: '<p>确认退出系统吗？</p>',
        onOk: () => {
          localStorage.JWT_TOKEN = '';
          localStorage.XJ_TICKET = '';
          localStorage.userPermissions = '';
          localStorage.userInfo = '';
          localStorage.setItem('JWT_TOKEN', '');
          localStorage.setItem('user', '');
          this.$router.push({ path: '/login' });
          // window.location.href = `${util.getProtocol()}${process.env.VUE_APP_API_HOST}/user/exit_logout`;
        }
      });
    },
    checkUser () {
      const JWT_TOKEN = window.localStorage.getItem('JWT_TOKEN');
      if (!JWT_TOKEN) {
        this.$Message.warning('当前用户登录信息已过期，请重新登录！');
        this.$router.push({ path: '/login' });
      }
    },
    setPageHeight () {
      const aside = document.getElementById('content-wrapper');
      const minHeight = document.body.clientHeight;
      aside.style.minHeight = `${minHeight - 130}px`;
    },
    scrollToTop () {
      const scrollTopVal = document.getElementById('content-wrapper').scrollTop;
      if (scrollTopVal > 200) {
        this.isShowToTop = true;
      } else {
        this.isShowToTop = false;
      }
    },
    goTop () {
      document.getElementById('content-wrapper').scrollTop = 0;
    },
    handleCloseTag (res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName);
        } else {
          if (util.routeEqual(this.$route, route)) {
            this.closeTag(route);
          }
        }
      }
      this.setTagNavList(res);
    },
    handleClick (item) {
      this.turnToPage(item);
    }
  },
  watch: {
    '$route' (newRoute, oldRoute) { // 面包屑设置
      this.isShowBg = newRoute.name == 'home';
      if (!newRoute.meta.hideInMenu) {
        this.setBreadCrumb(this.$route);
        this.$refs.sideMenu.updateOpenName(newRoute.name);
      }
      this.activeName = newRoute.name;
      const { name, query, params, meta } = newRoute;
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      });
      this.setTagNavList(util.getNewTagList(this.tagNavList, newRoute));
      this.$store.commit('changeFooterButtonArr', []); // 更新是否显示footer按钮
    }
  },
  mounted () {
    this.checkUser();
    this.setTagNavList();
    const { name, params, query, meta } = this.$route;
    this.addTag({ route: { name, params, query, meta } });
    this.setHomeRoute(routers);
    this.setBreadCrumb(this.$route);
    this.isShowBg = this.$route.name == 'home';
    this.setPageHeight();
    window.onresize = () => {
      this.setPageHeight();
    };
    document.getElementById('content-wrapper').addEventListener('scroll', this.scrollToTop);
  },
  components: {
    SideMenu,
    HeaderBar
  }
};
</script>
<style scoped>
  #content-wrapper { position: relative;overflow-x: hidden;overflow-y: auto; }
  .fade-transform-leave-active, .fade-transform-enter-active { transition: all .2s; will-change: transform; }
  .fade-transform-enter { opacity: 0; transform: translateX(-30px); }
  .fade-transform-leave-to { opacity: 0; transform: translateX(30px); }
  .logo-con { height: 48px; overflow: hidden; padding: 12px 10px 0px 10px; margin-bottom: 16px; text-align: center; }
  .bgWelcome { display: block; position: absolute; top: 50%; left: 50%; margin-top: -300px; margin-left: -300px; max-width: 600px; }
</style>
